import { footerNav } from "@/pages/home/data";

const COLUMN_LINKS: Record<string, string> = {
  综艺幕后: "#picks",
  幕后真相: "#picks",
  品牌瓜: "#picks",
  直播热点: "#picks",
  舆论观察: "#picks",
  细节深挖: "#picks",
};

const ABOUT_LINKS: Record<string, string> = {
  关于看吃瓜: "#about",
  编辑部理念: "#about",
  内容原则: "#about",
  联系方式: "#about",
};

const SERVICE_LINKS: Record<string, string> = {
  订阅周报: "#subscribe",
  投稿爆料: "#about",
  合作联系: "#about",
  隐私与纠错: "#guide",
};

function linkFor(group: string, label: string) {
  if (group === "columns") return COLUMN_LINKS[label] || "#picks";
  if (group === "about") return ABOUT_LINKS[label] || "#about";
  return SERVICE_LINKS[label] || "#guide";
}

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-12">
          {/* 品牌 */}
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-wide text-background-50">看吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/75">
              一个以“深扒”为核心的娱乐内容媒体。不止看表面热闹，更带你挖背后故事——从事件真相到内幕解析，我们把被忽略的线索串起来。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-douban-fill", "ri-youtube-line"].map((ic, i) => (
                <a
                  key={i}
                  href="#about"
                  aria-label="社交媒体入口"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* 栏目 */}
          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-widest text-accent-300">热门栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {footerNav.columns.map((c) => (
                <li key={c}>
                  <a href={linkFor("columns", c)} className="text-sm text-background-100/75 transition-colors hover:text-accent-300">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 关于 */}
          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-widest text-accent-300">关于我们</h4>
            <ul className="mt-4 space-y-2.5">
              {footerNav.about.map((c) => (
                <li key={c}>
                  <a href={linkFor("about", c)} className="text-sm text-background-100/75 transition-colors hover:text-accent-300">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 服务与联系 */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-bold uppercase tracking-widest text-accent-300">服务与联系</h4>
            <ul className="mt-4 space-y-2.5">
              {footerNav.service.map((c) => (
                <li key={c}>
                  <a href={linkFor("service", c)} className="text-sm text-background-100/75 transition-colors hover:text-accent-300">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex items-center gap-2 rounded-lg bg-background-50/10 p-3 text-sm">
              <i className="ri-mail-open-line text-accent-300" aria-hidden="true"></i>
              <span>editor@kanchigua.example.com</span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/55">
            © 2026 看吃瓜 · 深扒娱乐内容媒体。理性吃瓜，尊重事实与当事人。
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-100/55">
            <a href="#guide" className="transition-colors hover:text-accent-300">
              隐私说明
            </a>
            <a href="#guide" className="transition-colors hover:text-accent-300">
              纠错反馈
            </a>
            <a href="#about" className="transition-colors hover:text-accent-300">
              商务合作
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}